export const sameDayCollectionMessage = 'For collection today your gift will be ready 1 hour 30 minutes after we’ve received the order';
export const futureDayCollectionMessage = 'Your gift will be made fresh on the day you have selected, please collect your gift 1 hour 30 minutes after the shop is open.';
export const oldCustomerAlertMessageFF = 'Uh oh, looks like you’ve already ordered with us so you can’t use this code. Sorry!';
export const oldCustomerAlertMessageUK = 'Sorry it looks like you’ve ordered with us before, so you can’t use this code.';
export const signInRegisterAlertMessageFF = 'To snag your first order discount, please';
export const signInRegisterAlertMessageUK = 'To get your first order discount please';
export const invalidPromoCodeAlertMessage = 'The promotional code you entered is not valid.';
export const promotionalCodeApplyError = 'There has been an error applying the promotional code, please try again.';
export const emailSubject = 'Problem changing privacy settings';
export const privacySuccessMessage = 'Your privacy settings have been saved.';
export const privacyErrorMessage = 'There was a problem. Please contact us at';
export const deliveryInstructionNote = 'Please be patient, untill i open the door';
export const deliveryInstructionOption = 'Please be patient';
export const deliveryInstructionOptionNotToshow = 'Press to select';
export const deliveryInstructionLable = 'Delivery instructions';
export const ERROR_TOWN_LIST_PREFIX = 'Error retrieving a list of towns for';
export const ERROR_COUNTY_LIST_PREFIX = 'Error retrieving a list of counties for';
export const FLORISTS_NEAR_YOU = 'Florists near';
export const CHANGE_FLORIST = 'Change florist';
export const START_NEW_SEARCH = 'Start new search';
export const SEARCH_NEW_ADDRESS = 'Search new address';
export const LOAD_MORE_FLORISTS = 'Load more florists';
export const SELECT_FLORIST = 'Select florist';
export const OCCASION_REQUIRED_MESSAGE = 'Please select an occasion';
export const DELIVERY_INSTRUCTION_LINK = 'Want to add extra delivery instructions?';
export const DAYPICKER_ERROR_MESSAGE = 'Select a delivery date';
export const CHOOSE_DATE = 'Choose a date';
export const CHOOSE_ADDRESS = 'Choose a delivery address';
export const CHOOSE_AN_OCCASION = 'Choose an occasion';
export const INTERNATIONAL_DELIVERY = 'International delivery';
export const ENTER_DELIVERY_ADDRESS = 'Enter delivery address';
export const LIST_VIEW = 'List View';
export const MAP_VIEW = 'Map View';
export const RECOMMENDED = 'Recommended';
export const READ_TIME = 'Read time - {count} mins';
export const READ_MORE = 'Read more';
export const READ_LESS = 'Read less';
export const collectionInstructionsTitle = 'Collection instructions';
export const collectionText = 'The florist will need a minimum of 1 hour 30 minutes to prepare your flowers, but you can specify a preferred collection time below';
export const collectionInstructionPlaceholder = 'For example...\n1.30pm (in my lunch break)';
export const OCCASION_PERSONALISED_MESSAGES = {
    "Mother's Day": 'Happy Mother’s Day.\n\nLots of love,',
    Birthday: 'Happy birthday! Hope you have a brilliant day.',
    Friendship: 'Thanks for being an amazing friend.',
    Sympathy: 'I’m so sorry, sending all my love.',
    'Thinking of You': 'Thinking of you and sending love.',
    'Thank You': 'Thank you so much for everything!',
    Anniversary: 'Happy anniversary to my special someone.',
};
export const PDP_COLLECTION_STEP_2_TITLE = 'Would you like your order delivered?';
export const PDP_DELIVERY_STEP_2_TITLE = 'Who is this gift for?';
export const PRODUCTDETAIL = 'ProductDetail';
export const standardDeliveryType = 'Delivery';
export const collectionDeliveryType = 'Collection';
export const COLLECT_FROM_FLORIST = 'Collect from florist';
export const deliveryTypes = [
    { title: 'Delivery', icon: 'local_shipping', description: 'by local florist', cta_label: 'Next: Delivery date' },
    { title: 'Collection', icon: 'store', description: 'from local florist', cta_label: 'Next: Collection date' },
];
export const CTA_ADDRESS_FF = 'Next: Delivery date';
export const CTA_ADDRESS_IF_MOBILE = 'Next';
export const FREE_LABEL = 'FREE';
export const ADDRESS_PLACEHOLDER_EIRCODE = 'Try the eircode or street name';
export const ADDRESS_PLACEHOLDER_COLLECTION = 'Enter town or postcode';
export const ADDRESS_PLACEHOLDER_COLLECTION_IE = 'Try the town or eircode';
export const ADDRESS_PLACEHOLDER_DELIVERY = 'Enter delivery postcode';
export const PDP_COLLECTION_STEP_3_TITLE = 'When and where would you like to collect your gift?';
export const PDP_FF_DELIVERY_STEP_3_TITLE = 'Choose a delivery date';
export const PDP_DROPSHIP_STEP_3_TITLE = 'When would you like your gift to be delivered?';
export const PDP_STEP_3_TITLE = 'When would you like your gift?';
export const DELIVERY_OPTION_TITLE = 'Select a delivery option for';
export const COLLECTION_OPTION_TITLE = 'Collect from florist on';
export const COLLECTION_ADDRESS_LABEL = 'Search for collection address';
export const COLLECTION_ADDRESS_PLACEHOLDER = 'Search for town';
export const COLLECTION_ADDRESS_REQUIRED_MESSAGE = 'Please select an address from the list';
export const COUNTRY_REQUIRED_ERROR_MESSAGE = 'Please select a country';
export const COLLECTION_AVAILABILITY_ERROR_MESSAGE = 'The collection availability check returned an error response:';
export const UNAVAILABLE_MODAL_TITLE = 'We can’t quite do that';
export const COLLECTION_UNAVAILABLE_MODAL_DESCRIPTION = `We're really sorry, but you can’t collect the `;
export const COLLECTION_UNAVAILABLE_MODAL_DESCRIPTION_2 = 'from that location on that day.';
export const COLLECTION_UNAVAILABLE_MODAL_SUB_DESCRIPTION = 'Choose one of the following instead:';
export const CHOOSE_DELIVERY_OPTION = 'Choose a delivery option';
export const CHANGE_COLLECTION_ADDRESS = 'Change collection address';
export const CHANGE_DELIVERY_DATE = 'Choose a different date';
export const STEM_SPECIFIC_PRICING = {
    displayText: 'Choose number of ',
    descriptionText: 'Same day delivery available for up to ',
};
export const SPECIAL_INSTRUCTIONS_TITLE = 'Do you have any special requests?';
export const STEMS_SPECIFIC_TITLE = 'How many {stems} would you like?';
export const VARIANT_TITLE = 'What {variant} would you like?';
export const VARIANT_TITLE_TEXT = `Choose your {titleVariant}`;
export const NO_SPECIAL_INSTRUCTIONS_LABEL = '(No special request entered)';
export const FROM = 'From';
export const VIEW_AVAILABLE_GIFTS = 'View available gifts';
export const VIEW_SUITABLE_GIFTS = 'View suitable gifts';
export const SAVE_OCCASION = 'Save occasion';
export const PCC_EDIT_TRACKING_LOCATION = {
    1: 'date',
    2: 'address',
    3: 'occasion',
};
export const COLLECTION_DETAILS_TITLES = {
    selectedFloristShop: 'Your selected florist shop:',
    collectionFrom: 'Collection From:',
    collectFromFlorist: 'Collect from florist',
    emailNotification: 'You’ll be sent an email when it’s ready to collect',
};
export const PRODUCT_QUERY_PARAMS = 'productQueryParams';
export const INTERNATIONAL = 'international';
export const INTERNATIONAL_DROPDOWN_TITLE = 'Where would you like delivery to?';
export const LIVE_CHAT = 'Live chat';
export const LIVE_CHAT_UNAVAILABLE = 'Live chat unavailable';
export const LIVE_CHAT_AVAILABLE_SOON = 'Live chat available soon';
export const LIVE_CHAT_UNAVAILABLE_LABEL = `Live chat\n(Unavailable)`;
export const LIVE_CHAT_AVAILABLE_SOON_LABEL = `Live chat\n(Available soon)`;
export const PLEASE_SELECT = 'Please select';
export const FOOTER_LIVE_CHAT_TEXT = 'Live chat';
export const FOOTER_LIVE_CHAT_SOON_TEXT = 'Live chat (Available soon)';
export const FOOTER_LIVE_CHAT_UNAVAILABLE_TEXT = 'Live chat (Unavailable)';
export const FOOTER_LIVE_CHAT_ENABLED_ICON_ALT = 'chat enabled icon';
export const FOOTER_LIVE_CHAT_UNAVAILABLE_ICON_ALT = 'chat disabled icon';
export const FOOTER_LIVE_CHAT_SOON_ICON_ALT = 'chat available soon icon';
export const DELIVERY_UNAVAILABLE_PRODUCTS_UNAVAILABLE_MODAL = {
    modalTitle: 'Delivery unavailable',
    productContent: 'Unfortunately, we are unable to deliver any gifts to your requirements. Please change your delivery date or address to see available gifts.',
};
export const FF_DELIVERY_UNAVAILABLE_PRODUCTS_MODAL = {
    modalTitle: 'Ah, we’ve hit a snag',
    productContent: 'We’re really sorry but we can’t get <span>${productName}</span> to that address on that date. How about one of these instead?',
};
export const DOMESTIC_DELIVERY_UNAVAILABLE_PRODUCTS_UNAVAILABLE_MODAL = {
    modalTitle: 'We can’t quite do that',
    productContent: "We're really sorry, but you can’t deliver the <span>${productName}</span> to that address on that day.<br><br>Choose one of the following instead:",
};
export const DELIVERY_UNAVAILABLE_PRODUCTS_AVAILABLE_MODAL = {
    modalTitle: 'We can’t quite do that',
    productContent: "We're really sorry, but we can’t deliver <span>${productName}</span> to that address on that day. How about one of these instead?",
};
export const BIRTHDAY_CAMPAIGN = {
    CLAIM_BOUQUET_CTA_LINK: 'Claim your birthday bouquet',
    ALL_FLOWERS: 'All flowers',
    LOSER_TITLE: 'Sorry',
    LOSER_SUBTITLE: "You've not got a bouquet this time",
    WINNER_TITLE: 'Congratulations!',
    WINNER_SUBTITLE: "You're a winner",
    WINNER_DESCRIPTION: 'Hooray! You’ve won a bouquet worth £48.50 but you’ll pay just £1, and we’ll donate that to The Great Friendship Project. We’ve applied your discount, and we just need a few more details to finish up your order.',
    PARTICIPATION_TITLE: 'Birthday Spinning Wheel',
    FEELING_LUCKY: 'Feeling lucky?',
    PARTICIPATION_SUBTITLE: 'Spin the wheel!',
    PARTICIPATION_DESCRIPTION: 'You could nab a birthday bouquet worth £48.50 for just £1...',
    LOSER_SUBTITLE_2: "But here's a code for 15% off your next order instead.",
    LOSER_SUBTITLE_3: `Just pop the code $code`,
    LOSER_SUBTITLE_4: 'in at the checkout.',
    LOSER_SUBTITLE_5: "And don't forget to spin the wheel again tomorrow!",
    LOSER_URL: '/category/flower-arrangements',
    WINNER_URL: '/product/surprise-design-gift-box-ccgbu0100s',
};
export const birthdayCompetitionTermsTitle = 'Competition terms';
export const birthdayCompetitionTerms = [
    'Open to UK residents aged 18 or over only, excluding employees and their immediate families of the Promoters, its agents, associates, printers or anyone professionally connected with the promotion.',
    'The £1 birthday bouquets will be available to win every day of the week with limited numbers available each day from 09:00 GMT Friday 5th September 2025 until midnight Tuesday 30th September 2025.',
    'Entrant’s participation is via ${interflora.co.uk}/${interflora.ie} only. The Promoters cannot guarantee uninterrupted or secure access to this entry route.',
    'Entries are limited to one per person.',
    'By entering this promotion, entrants give consent to receive offers, updates and marketing from the Promoter. You can opt out at any time. We will treat your personal information with respect and use it as detailed in our ${Privacy Policy}.',
    'There will be multiple winners every week from Friday 5th September 2025 until Tuesday 30th September 2025.',
    'Each winner will be able to purchase a Luxurious Bright Bouquet, worth £48.50, for £1.',
    'Prize excludes delivery. All prizes must be collected from the local florist named in the order confirmation at no additional cost.',
    'There are no cash alternatives, the prize is not transferable or exchangeable.',
    'By entering the promotion, entrants agree to be bound by these terms and conditions and by the decisions of the Promoter that are final in all matters relating to the promotion. No correspondence will be entered into. These terms and conditions do not affect your statutory rights.',
    'The Promoter is not responsible for any problems or technical malfunction of computer on-line systems, servers, or providers, computer equipment or software, or traffic congestion on the internet, or any combination of these, including any injury or damage to entrant’s or any other person’s computer related to or resulting from participation in the promotion.',
    'This competition is run by the Promoter: Interflora British Unit, Interflora House, Watergate, Sleaford, Lincolnshire, NG34 7TB, England',
    'The Promoter reserves the right to terminate, amend or extend this promotion.',
    'Please retain these terms and conditions for future reference.',
    'Entry to this giveaway will be deemed to constitute full acceptance of these terms and conditions.',
];
